import { Sparkles, X, Check } from 'lucide-react';
import { REWRITE_STYLES } from './selection';

/**
 * Style picker row inside the AIRewriteMenu popover. Pure presentational.
 */
export function StylePicker({ activeStyle, loading, onPick }) {
  return (
    <div className="flex flex-wrap gap-1">
      {REWRITE_STYLES.map((s) => (
        <button
          key={s.key}
          data-testid={`ai-rewrite-style-${s.key}`}
          onClick={() => onPick(s.key)}
          disabled={loading}
          className="px-2 py-1 rounded-full text-[10px] font-medium transition-colors"
          style={{
            background: activeStyle === s.key ? 'var(--pd-focus)' : 'var(--pd-surface-1)',
            color: activeStyle === s.key ? 'white' : 'var(--pd-text-secondary)',
            border: '1px solid var(--pd-border-base)',
            opacity: loading && activeStyle !== s.key ? 0.4 : 1,
          }}
        >
          {s.label}
        </button>
      ))}
    </div>
  );
}

/**
 * Popover header — title + close button. Pure presentational.
 */
export function AIRewriteHeader({ onClose }) {
  return (
    <div
      className="flex items-center justify-between px-3 py-2"
      style={{ borderBottom: '1px solid var(--pd-border-base)' }}
    >
      <div
        className="flex items-center gap-1.5 text-[11px] font-semibold"
        style={{ color: 'var(--pd-text-primary)' }}
      >
        <Sparkles className="w-3 h-3" style={{ color: 'var(--pd-focus)' }} />
        AI rewrite
      </div>
      <button onClick={onClose} className="p-1 rounded hover:bg-white/[0.06]" aria-label="Close">
        <X className="w-3 h-3" style={{ color: 'var(--pd-text-tertiary)' }} />
      </button>
    </div>
  );
}



/**
 * Result panel — shown after a successful rewrite. Pure presentational.
 * Caller wires in the replace/copy callbacks.
 */
export function AIRewriteResult({ rewritten, snapshotKind, onReplace, onCopy }) {
  return (
    <div className="px-3 py-3" style={{ borderTop: '1px solid var(--pd-border-base)' }}>
      <div
        data-testid="ai-rewrite-result"
        className="text-[12px] mb-2.5 p-2 rounded-lg max-h-32 overflow-y-auto whitespace-pre-wrap"
        style={{
          background: 'var(--pd-surface-1)',
          color: 'var(--pd-text-primary)',
          border: '1px solid var(--pd-border-base)',
        }}
      >
        {rewritten}
      </div>
      <div className="flex gap-1.5">
        {snapshotKind === 'input' ? (
          <button
            data-testid="ai-rewrite-replace"
            onClick={onReplace}
            className="flex-1 flex items-center justify-center gap-1 px-3 py-1.5 rounded-lg text-[11px] font-semibold"
            style={{ background: 'var(--pd-focus)', color: 'white' }}
          >
            <Check className="w-3 h-3" /> Replace
          </button>
        ) : null}
        <button
          data-testid="ai-rewrite-copy"
          onClick={onCopy}
          className="flex-1 px-3 py-1.5 rounded-lg text-[11px] font-semibold"
          style={{
            background: 'var(--pd-surface-2)',
            color: 'var(--pd-text-primary)',
            border: '1px solid var(--pd-border-base)',
          }}
        >
          Copy
        </button>
      </div>
    </div>
  );
}